import React from 'react';
import { Button } from 'antd';
import { useHistory } from 'react-router';
import useAuth from 'core/hooks/useAuth';
import AccessResourcesDenied from './AccessResourcesDenied';

const AccountAccessDenied = ({ children, title, types = [] }) => {
  const { hasAccountType } = useAuth();
  const history = useHistory();

  const handleChangeSubscription = () => {
    history.push('/app/subscriptions');
  };

  if (types?.length === 0) {
    return null;
  }

  if (hasAccountType(...types)) {
    return (
      <AccessResourcesDenied
        title={title}
        subTitle="Para ter acesso a todos os recursos faça upgrade da sua assinatura."
        extra={
          <Button onClick={handleChangeSubscription} type="primary">
            Upgrade de assinatura
          </Button>
        }
      />
    );
  }

  return children;
};

export default AccountAccessDenied;
